import React from 'react';
import { Box, Container, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

export const HostCtaSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        bgcolor: '#f59842',
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          textAlign: 'center',
          px: { xs: 2, md: 3 },
        }}
      >
        <Typography
          variant={isMobile ? 'h5' : 'h4'}
          component="h2"
          sx={{ fontWeight: 700, color: '#ffffff', mb: 2 }}
        >
          Share your space, earn extra income
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255,255,255,0.9)',
            mb: 4,
            maxWidth: 480,
            mx: 'auto',
            lineHeight: 1.6,
          }}
        >
          Join thousands of hosts on BnBCart. List your property in minutes and start welcoming guests from around the world.
        </Typography>
        <Button
          variant="contained"
          size="large"
          component={Link}
          to="/auth/register"
          sx={{
            bgcolor: '#ffffff',
            color: '#f59842',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.9)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 200ms ease',
          }}
        >
          List your property
        </Button>
      </Container>
    </Box>
  );
};
